const messages = {
    google: 'Unable to authorise Google account',
    xylem: 'Unable to authorise Xylem Cloud account',
    basic: 'Unable to sign in with username and password',
    unknown: 'Unable to sign in',
    disabled: 'Your account has been disabled. Contact support@devicepilot.com for more information.',
};
export default class InvalidCredentialsError extends Error {
    provider;
    dpError;
    constructor(provider = 'basic') {
        const message = messages[provider] || messages.unknown;
        super(message);
        this.provider = provider;
        this.dpError = true;
    }
}
